import { SourceTypeResponse, SourceTypesQueryResponse } from "api/company";
import { SourceType } from "model";

export function getPrioritySourceType(
  sourceTypes: SourceTypesQueryResponse
): SourceTypeResponse | undefined {
  return getSortedSourceTypes(sourceTypes)[0];
}

export function getNextPrioritySourceType(
  sourceTypes: SourceTypesQueryResponse,
  sourceType: SourceTypeResponse
): SourceTypeResponse | undefined {
  const sortedSourceTypes = getSortedSourceTypes(sourceTypes);
  const index = sortedSourceTypes.findIndex(
    (s) => s.sourceType === sourceType.sourceType
  );
  return index !== -1 ? sortedSourceTypes[index + 1] : undefined;
}

function getSortedSourceTypes(sourceTypes: SourceTypesQueryResponse) {
  return sourceTypes.sort((a, b) => a.priority - b.priority);
}

export function sourceTypeHasData(sourceType: SourceTypeResponse) {
  return sourceType.connected > 0 || (sourceType.uploadedFiles ?? 0) > 0;
}

export const sourceTypePlatformName: Record<SourceType, string | undefined> = {
  Accounting: "accounting software",
  Banking: "bank account",
  Commerce: "commerce software",
  Other: "business documents",
};

export const sourceTypeFileName: Record<SourceType, string | undefined> = {
  Accounting: "accounting documents",
  Banking: "bank documents",
  Commerce: "files",
  Other: "business documents",
};

export const sourceTypeSelectionText: Record<SourceType, string> = {
  Accounting: `Select your ${sourceTypePlatformName["Accounting"]}`,
  Banking: "Connect your bank account",
  Commerce: `Select your ${sourceTypePlatformName["Commerce"]}`,
  Other: `Select your ${sourceTypePlatformName["Other"]}`,
};
